import { render, staticRenderFns } from "./deposit_account_record_list.vue?vue&type=template&id=22a53ec5&scoped=true"
import script from "./deposit_account_record_list.vue?vue&type=script&lang=js"
export * from "./deposit_account_record_list.vue?vue&type=script&lang=js"
import style0 from "./deposit_account_record_list.vue?vue&type=style&index=0&id=22a53ec5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a53ec5",
  null
  
)

export default component.exports